import React, { Fragment } from 'react';
import Header6 from '../../components/header6/Header6';
import Hero6 from '../../components/hero6/hero6';
import FeaturesService from '../../components/Help-Desk-Components/FeaturesService/FeaturesService';
import FeatureSection from '../../components/Help-Desk-Components/FeatureSection/FeatureSection';
import FunFactSection from '../../components/Help-Desk-Components/FunFact/FunFact';
import CtaSection from '../../components/Help-Desk-Components/CtaSection/CtaSection';
import Footer from '../../components/Help-Desk-Components/Footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

import About from '../../components/about/about';


const HomePage6 = () => {
    

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <Fragment>
            <div className='help_desk'>
                <main className="page_content">
                    <Header6 />
                    <Hero6 />
                    {/* <PartnerSection /> */}
                    <FeaturesService />
                  
                    <FeatureSection />
                    <About/>
                    <FunFactSection />
                    {/* <IntegrationSection /> */}
                    {/* <Testimonial /> */}
                    {/* <HelpDeskBlogSection /> */}
                    {/* <IndustrieSection /> */}
                    <CtaSection />
                    
                    <Scrollbar />
                </main>
                <Footer/>
            </div>
        </Fragment>
    )
};
export default HomePage6;